import { ReactNode } from "react"
import modernNormalize from "styled-modern-normalize"
import { createGlobalStyle, CSS } from "../styles"

const generateGlobalStyle = (css?: CSS) =>
  createGlobalStyle`
    ${modernNormalize}
    ${css}
  `

interface Props {
  children: ReactNode
  css?: CSS
}

export const GlobalStyles: React.FC<Props> = ({ children, css }: Props) => {
  const GlobalStyle = generateGlobalStyle(css)
  return (
    <>
      <GlobalStyle />
      {children}
    </>
  )
}

GlobalStyles.defaultProps = {
  css: undefined,
}
